import React from "react";

/**
 * ErrorBoundary — catches render errors so a single component crash doesn't
 * take down the entire app (which in an Android WebView shows the "Bug in
 * the app · Clear cache" native dialog).
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary]", error, info?.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="p-6 max-w-lg mx-auto text-sm">
          <div className="rounded-2xl border border-rose-500/30 bg-rose-500/5 p-5">
            <div className="font-semibold text-rose-600 mb-2">Something went wrong on this page.</div>
            <div className="text-muted-foreground mb-4">
              You can safely go back or reload — the rest of the app is still working.
            </div>
            <div className="flex gap-2">
              <button
                type="button"
                onClick={() => window.history.back()}
                className="px-3 py-2 rounded-lg bg-primary text-primary-foreground text-sm"
              >
                Go back
              </button>
              <button
                type="button"
                onClick={() => this.setState({ error: null })}
                className="px-3 py-2 rounded-lg border border-border text-sm"
              >
                Try again
              </button>
            </div>
            {process.env.NODE_ENV !== "production" && (
              <pre className="mt-4 text-[10px] whitespace-pre-wrap overflow-auto max-h-40 bg-muted p-2 rounded">
                {String(this.state.error?.stack || this.state.error?.message || this.state.error)}
              </pre>
            )}
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
